import { css } from 'styled-components'

/** Visual disabled state : lowered opacity. */
export const disabled = css`
  opacity: 0.5;
  pointer-events: none;
`
